export enum RelationShipWithDeceased {
  CHILD = 'CHILD',
  SPOUSE = 'SPOUSE',
  OTHER_FAMILY_MEMBER = 'OTHER_FAMILY_MEMBER',
  NOTARY = 'NOTARY',
  OTHER_TIERS = 'OTHER_TIERS',
}
